(function () {
  'use strict';

  function formatMoney(cents) {
    return '\u00a3' + (cents / 100).toFixed(2);
  }

  function getBagIcon() {
    var tpl = document.getElementById('wt-bag-icon-tpl');
    return tpl ? tpl.innerHTML : '';
  }

  function buildCard(product) {
    var img = product.featured_image || (product.images && product.images[0]) || {};
    var rawSrc = (typeof img === 'string') ? img : (img.src || '');
    var imgSrc = rawSrc
      ? (rawSrc.indexOf('?') !== -1 ? rawSrc + '&width=300' : rawSrc + '?width=300')
      : '';
    var alt = ((typeof img === 'object' && img.alt) ? img.alt : product.title || '').replace(/"/g, '&quot;');
    var price = formatMoney(product.price_min || 0);
    var comparePrice = product.compare_at_price_min && product.compare_at_price_min > product.price_min
      ? '<s class="price-item price-item--regular">' + formatMoney(product.compare_at_price_min) + '</s> '
      : '';

    return '<div class="shoppable-product-card shoppable-product-card--cross-sell">'
      + '<a href="' + product.url + '" class="wt-dot__link" tabindex="0">'
      + '<picture class="wt-dot__picture">'
      + (imgSrc ? '<img src="' + imgSrc + '" alt="' + alt + '" class="wt-dot__image" loading="lazy" width="300">' : '')
      + '</picture>'
      + '<div class="wt-dot__body">'
      + '<div class="wt-dot__title">' + product.title + '</div>'
      + '<div class="wt-dot__price">' + comparePrice + '<span class="price-item price-item--sale">' + price + '</span></div>'
      + '</div>'
      + '</a>'
      + '<div class="shoppable-video__buttons">'
      + '<quick-add data-product-handle="' + product.handle + '">'
      + '<button type="submit" class="shoppable-video__add-button" aria-label="Add to cart" data-product-url="' + product.url + '">'
      + getBagIcon()
      + '</button>'
      + '</quick-add>'
      + '</div>'
      + '</div>';
  }

  function initDragScroll(el) {
    var isDown = false, startX, scrollLeft;
    el.addEventListener('mousedown', function (e) {
      isDown = true;
      el.classList.add('is-dragging');
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    });
    document.addEventListener('mouseup', function () {
      isDown = false;
      el.classList.remove('is-dragging');
    });
    el.addEventListener('mouseleave', function () {
      isDown = false;
      el.classList.remove('is-dragging');
    });
    el.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - el.offsetLeft;
      el.scrollLeft = scrollLeft - (x - startX);
    });
  }

  function fetchForProduct(productId, limit) {
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) { return data.products || []; })
      .catch(function () { return []; });
  }

  function loadRecommendations() {
    var container = document.getElementById('wt-cart-cross-sell-app');
    if (!container) return;
    var productId = container.dataset.productId;
    if (!productId) return;
    if (container.dataset.loaded === productId) return;
    container.dataset.loaded = productId;

    var limit = parseInt(container.dataset.limit, 10) || 4;
    var slidesContainer = document.getElementById('wt-app-recs-slides');
    if (!slidesContainer) return;

    var cartIdsRaw = (container.dataset.cartIds || productId)
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var inCart = {};
    cartIdsRaw.forEach(function (id) { if (id) inCart[id] = true; });

    fetchForProduct(productId, limit).then(function (products) {
      products = products.filter(function (p) { return !inCart[String(p.id)]; }).slice(0, limit);
      if (!products.length) return;
      slidesContainer.innerHTML = products.map(buildCard).join('');
      initDragScroll(slidesContainer);
      container.removeAttribute('style');
    });
  }

  function init() {
    loadRecommendations();
    var cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) {
      var debounceTimer;
      new MutationObserver(function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(loadRecommendations, 80);
      }).observe(cartDrawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
